import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ProjectModel } from 'src/app/models/project.model';
import { CutoffService } from 'src/app/services/cutoff.service';
import { InventorysService } from 'src/app/services/inventory.service';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import { ProjectsDiagramationInventoryDetailComponent } from '../../dialogs/projects-diagramation-inventory-detail/projects-diagramation-inventory-detail.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-projects-diagramation-inventory',
  templateUrl: './projects-diagramation-inventory.component.html',
  styleUrls: ['./projects-diagramation-inventory.component.scss']
})
export class ProjectsDiagramationInventoryComponent implements OnInit { 

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  project: ProjectModel = new ProjectModel();
  displayedColumns: string[] = [];
  allColumns: string[] = [];
  dataSource: any = [];
  data_inv: any = [];
  totales : any = [];

  constructor(
    private matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data : any,
    private projectService : ProjectsService,
    private main : MainService,
    private _cutoffS : CutoffService,
    private invService : InventorysService
  ) {
    this.project = data.project;
    
   }

  ngOnInit(): void {
    this._cutoffS.checkIfSameProjectThenReplace(this.data.project.id_proy_camp).then(x=>{
      this.getInventory();
    });
  }

  getInventory(){
    this.main.ShowLoading();
    this.invService.getInventoryGlobal({ id_proy: this.project.id, id_proy_campana: this.data.project.id_proy_camp }).subscribe({
      next: (response: any) => {
        this.main.HideLoading();
        if (response.message === "Success") {
          this.totales = response.data;
          this.data_inv = this.mapInventoryData(this.totales);
  
          if (this.data_inv.length > 0) {
            this.displayedColumns = Object.keys(this.data_inv[0]).filter(key => key && key.trim() !== '' && key !== 'data' && key !== 'all_media');
            this.allColumns = this.displayedColumns;
            this.dataSource = new MatTableDataSource(this.data_inv);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          }
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Aviso',
            text: 'No es posible mostrar el inventario, por favor inténtelo más tarde'
          });
        }
      },
      error: (err:any) => {
        this.main.HideLoading();
        console.error(err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrió un error al obtener el inventario.'
        });
      }
    });
  }

  private mapInventoryData(inventoryItems: any[]): any[] {
    const mappedData: any[] = [];
    inventoryItems.forEach(item => {
      if (!mappedData.some(d => d.Nombre === item.nombre)) {
        mappedData.push(this.transformInventoryItem(item, inventoryItems));
      }
    });
    return mappedData;
  }

  private transformInventoryItem(item: any, allItems: any[]): any {
    const sumConfigs = (pops: any[]) => pops.reduce((acc: number, pop: any) => acc + pop.configs.reduce((sum: number, c: any) => sum + c.cantidad, 0), 0);
    const sumConfigsUnidades = (pops: any[]) => pops.reduce((acc: number, pop: any) => acc + pop.configs.reduce((sum: number, c: any) => sum + (c.cantidad * c.posiciones), 0), 0);
    const sumConfigsUnidadesDiagramadas = (pops: any[]) => pops.reduce((acc: number, pop: any) => acc + pop.configs.reduce((sum: number, c: any) => sum + (c.cantidad * c.pos_diagramadas), 0), 0);

    let inventarioTotal = this.calculateTotalInventory(item, allItems, sumConfigs);
    let unidadesTotalesCalc = this.calculateTotalUnits(item, allItems, sumConfigsUnidades);

    const seleccionados = sumConfigs(item.pops_t);
    const posDiagramadas = item.pops.reduce((acc: number, pop: any) => acc + pop.pos_diagramadas, 0);
    const posiciones = item.position_icon;
    const esNumero = this.isNumber(posiciones);
    const unidadesDiagramadas = sumConfigsUnidadesDiagramadas(item.pops_t);
    const unidadesDisponibles = unidadesTotalesCalc - unidadesDiagramadas;

    return {
      Nombre: item.nombre,
      Posiciones: posiciones,
      ["Pos. Diagramadas"]: posDiagramadas,
      ["Pos. Disponibles"]: esNumero ? (posiciones - posDiagramadas) : posiciones,
      ["Inventario Total"]: inventarioTotal,
      ["Inventario Seleccionado"]: seleccionados,
      ["Inventario Disponible"]: inventarioTotal - seleccionados,
      ["Unidades Totales"]: unidadesTotalesCalc,
      ["Unidades Diagramadas"]: unidadesDiagramadas,
      ["Unidades Disponibles"]: unidadesDisponibles,
      data: item,
      all_media: allItems.filter((x: any) => x.id_medio == item.id_medio)
    };
  }

  private calculateTotalInventory(item: any, allItems: any[], sumConfigs: (pops: any[]) => number): number {
    if (item.tipo === 4) {
      return item.inventario_max;
     // return this.calcTotalesMedio(allItems, item.id_medio);
    }
    if (item.tipo === 1) {
      return item.inventario;
    }
    if (item.tipo !== 2) {
      return sumConfigs(item.pops);
    }
    return this.calcTotalesMedio(allItems, item.id_medio);
  }

  private calculateTotalUnits(item: any, allItems: any[], sumConfigsUnidades: (pops: any[]) => number): number {
    if (item.tipo === 4) {
      return this.calcTotalesMedioPosiciones(allItems, item.id_medio);
    }
    return sumConfigsUnidades(item.pops);
  }

  calcTotalesMedio(dt_totales: any, id_medio = 0){
    let total = 0;
    dt_totales.map((e: any) => {
      if(e.id_medio == id_medio){
        total += e.inventario;
      }
     });
    return total;
  }

  calcTotalesMedioPosiciones(dt_totales: any, id_medio = 0){
    let total = 0;
    dt_totales.map((e: any) => {
      if(e.id_medio == id_medio){
        const pos = e.pops.find((x:any)=>x.id_pop == e.id_pop).posiciones; 
        total += e.inventario * pos;
      }
     });
    return total;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

   if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
   }
  }

  generateExcelResumen(){
    if(this.data_inv.length == 0){
      Swal.fire({
        icon: 'warning',
        title: 'Aviso',
        text: 'No hay datos de resumen actualmente'          
      });
    }else{
    let impr = this.data_inv.map((e: any) => {
      const { data, all_media, ...rest } = e;
      return rest;
    });

    const pops = this.getPopsTotales(this.totales);
      this.main.generateMultiSheetExcel([impr, pops], "Inventario " + this.project.nombre, ["inv", "detalles"]);
    }
  }

getPopsTotales(totales: any[]) {

  let resultado: any[] = [];

  totales.forEach((e: any) => {
    let detalle = this.getPops(e);

    detalle.forEach((item: any) => {
      if (!resultado.some((d: any) => d.id_pop === item.id_pop)) {
        resultado.push(item);
      }
    });
  });

  return resultado.map(({ id_pop, ...rest }) => rest);
}

getPops(e: any) {
  const selectedMap = new Map<number, number>();

 
  (e.pops_t || []).forEach((pop: any) => {
    pop.configs.forEach((c: any) => {
      selectedMap.set(Number(c.id_pop_config), c.cantidad);
    });
  });

  const detalle: any[] = [];
  let seleccionado_sum = 0;

  if(e.tipo == 4){
    e.pops.forEach((pop: any) => {
         pop.configs.forEach((config: any) => {
          const s = selectedMap.get(config.id_pop_config) || 0;
          seleccionado_sum += s;
        });
    });
  }

  (e.pops || []).forEach((pop: any) => {
    let total = 0;
    let seleccionado = 0;

    pop.configs.forEach((config: any) => {
      if(e.tipo != 4){
         const t = config.cantidad;
         total += t;
      }else{
          total = e.inventario_max;
      }

      const s = selectedMap.get(config.id_pop_config) || 0;

    
      seleccionado += s;
    });

    detalle.push({
      id_pop : pop.id_pop,
      ["Nombre"]: pop.nombre,
      ["Pos. Totales"] : pop.posiciones,
      ["Pos. Diagramadas"]: pop.pos_diagramadas,
      ["Pos. Disponibles"]: pop.posiciones - pop.pos_diagramadas,
      ["Inventario Total"]: total,
      ["Inventario Seleccionado"]: seleccionado,
      ["Inventario Disponible"]: total - (e.tipo == 4 ? seleccionado_sum : seleccionado),
      ["Unidades Totales"]: total * pop.posiciones,
      ["Unidades Diagramadas"]:  seleccionado *  pop.pos_diagramadas ,
      ["Unidades Disponibles"]: (total * pop.posiciones) - 
       ((e.tipo == 4 ? seleccionado_sum : seleccionado) * ( e.tipo == 4  && pop.pos_diagramadas == 0 ? 1 :  pop.pos_diagramadas)),
    //  ["data_config"]: pop.configs 
    });
  });

  return detalle;
}

  isNumber(valor : any){
    return (valor !== "" && !isNaN(Number(valor))) 
  }

   openDetailDialog(data: any) {

      this.matDialog.open(ProjectsDiagramationInventoryDetailComponent, {
        panelClass: ['dialogs-lg'],
        data: {
          media: data
        }
      }).afterClosed().subscribe(
        (resp) => {
          if(resp) {
            
          }
        }
      );
    }
}
